<div [ngStyle]="{'background-color': bgInstitucion}" class="app-splash-screen">
  <div class="app-splash-inner">
    <div [ngStyle]="{'background': 'url(' + logoInstitucion + ')', 'background-repeat': 'no-repeat', 'background-position': 'center',
    'background-size': 'contain'}" class="app-logo">
    </div>
    <div class="app-label">Cargando Portal</div>
    <div class="app-loader"></div>
  </div>
</div>
